module.exports = __webpack_public_path__ + "static/media/s_v5_t7_2.133783f7.mp3";